import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Table, Typography, Button, Card, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import apiService from '../../services/api';

const { Title, Text } = Typography;

const fmtMoney = (v) => `£${Number(v || 0).toFixed(2)}`;
const orDash = (v) => v || <Text type="secondary">—</Text>;

const ExternalDriverJobs = () => {
  const navigate = useNavigate();
  const { driverId } = useParams();
  const [searchParams] = useSearchParams();
  const driverName = searchParams.get('name') || 'Driver';
  const month = dayjs(`${searchParams.get('month')}-01`);
  const start = month.startOf('month').format('YYYY-MM-DD');
  const end = month.endOf('month').format('YYYY-MM-DD');

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    apiService.dailyRuns.getAll({ driver: driverId, startDate: start, endDate: end })
      .then(res => setJobs(res.data || []))
      .catch(() => message.error('Failed to load jobs'))
      .finally(() => setLoading(false));
  }, [driverId, start, end]);

  const sum = (field) => jobs.reduce((s, j) => s + (j[field] || 0), 0);

  const columns = [
    { title: 'Date', dataIndex: 'date', key: 'date', width: 130, render: (d) => dayjs(d).format('ddd DD MMM') },
    { title: 'Client', dataIndex: 'channel', key: 'channel', render: orDash },
    { title: 'Reference', dataIndex: 'reference', key: 'reference', render: orDash },
    { title: 'Pickup', dataIndex: 'pickupPostcode', key: 'pickup', render: orDash },
    { title: 'Drop-off', dataIndex: 'dropOffPostcode', key: 'dropoff', render: orDash },
    { title: 'Charged', dataIndex: 'osp', key: 'osp', align: 'right', width: 110, render: fmtMoney },
  ];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />
        <div>
          <Title level={4} style={{ margin: 0 }}>{driverName}</Title>
          <Text type="secondary">{month.format('MMMM YYYY')}</Text>
        </div>
      </div>

      <Card size="small" title={`Jobs (${jobs.length})`}>
        <Table
          dataSource={jobs}
          columns={columns}
          rowKey="_id"
          loading={loading}
          pagination={false}
          size="small"
          scroll={{ x: 'max-content' }}
          locale={{ emptyText: 'No jobs this month' }}
          summary={() =>
            jobs.length > 0 ? (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={5}><Text strong>Total</Text></Table.Summary.Cell>
                <Table.Summary.Cell index={5} align="right"><Text strong>{fmtMoney(sum('osp'))}</Text></Table.Summary.Cell>
              </Table.Summary.Row>
            ) : null
          }
        />
      </Card>
    </div>
  );
};

export default ExternalDriverJobs;
